import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-transaction-order-edit',
  templateUrl: './transaction-order-edit.component.html',
  styleUrls: ['./transaction-order-edit.component.scss']
})
export class TransactionOrderEditComponent implements OnInit {
  @ViewChild("ngOtpInput", { static: false }) ngOtpInputRef: any;
  configTwo = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder: "-",
    inputStyles: {
      width: "20.5%",
      height: "60px",
      fontSize: "13px",
      padding: '15px',
      marginRight: '20px',
      marginTop: '15px',
      marginBottom: '15px',
      textAlign: 'center'
    },
  };
  @Input() timeToVerify: any;
  @Input() buttonApprove: Boolean;
  @Input() orderEditModalPageOne: Boolean;
  @Input() orderEditModalPageTwo: Boolean;
  @Input() orderEditModalPageThree: Boolean;
  @Input() paymentReceipt:any;
  @Input() currency:any;
  @Input() employees:any[];
  @Input() userSelected:any;
  @Input() editPayment:any;
  @Input() tipAmount:any;
  @Input() chageLoader:Boolean;
  @Output() otpEmit: EventEmitter<any> = new EventEmitter();
  @Output() nextPage: EventEmitter<any> = new EventEmitter();
  @Output() selectTransactionEditOrder: EventEmitter<any> = new EventEmitter();
  @Output() changeValueSelect: EventEmitter<any> = new EventEmitter();
  @Output() changeAmount: EventEmitter<any> = new EventEmitter();
  @Output() changeTipFunction: EventEmitter<any> = new EventEmitter();
  @Output() resendOtpEditOrder: EventEmitter<any> = new EventEmitter();
  constructor() { }
  ngOnInit(): void {
  }
  changeOtp(event) {
    var code = +event
    if (code.toString().length == 4) {
      this.otpEmit.emit(code)
    }
  }
  nextPageFunc() {
    this.nextPage.emit()
  }
  clearOtp() {
    this.ngOtpInputRef.setValue("")
  }
  selectTransactionEditOrderFunc(transaction:any, paymentReceipt:any, index:any) {
    var details = {
      transaction , paymentReceipt, index
    }
    this.selectTransactionEditOrder.emit(details)
  }
  changeValueSelectFunc(event) {
    console.log(event)
    this.changeValueSelect.emit(event)
  }
  change(event:any) {
    let data = event.value.replace(/\$/g, '')
      this.changeAmount.emit(data)
  }
  changeTipFunc() {
    this.changeTipFunction.emit()
  }
  resendOtpEditOrderFunc () {
    this.resendOtpEditOrder.emit()
  }

}
